import { Injectable } from '@angular/core';
import {months} from "../configs/line-chart-month-config";
import {LineChartDataParams, UpdateLineChartParams} from "../types/line-chart-modal.types";
import {defaultLineChartQueryParams} from "../configs/line-chart-modal-config";

@Injectable({
  providedIn: 'root'
})
export class LineChartMonthService {
  public getMonthName(monthId: number): string {
    const month = months.find(m => m.id === monthId);
    return month ? month.value : '';
  }

  public setLineChartDataParams(updateLineChartParams: UpdateLineChartParams, parentUrl: string): LineChartDataParams {
    const queryParams = {
      ...defaultLineChartQueryParams,
      sort: [
        'month,asc'
      ],
      productId: updateLineChartParams.selectedProductId,
      year: updateLineChartParams.selectedYear
    };

    return {
      path: parentUrl,
      queryParams: queryParams
    };
  }
}
